import { validateTidalLicense } from "../base/index.js";
import "../global.d.js";
export * from "./icons/index.js";
import * as illustrations from "./illustrations/index.js";
import * as logos from "./logos/index.js";
validateTidalLicense();
export {
  illustrations,
  logos
};
//# sourceMappingURL=index.js.map
